export const adminPl = {
  admin: {
    dashboard: {
      title: 'Panel Administracyjny',
      subtitle: 'Zarządzaj użytkownikami, kontenerami i przedmiotami',
      users: {
        title: 'Użytkownicy',
        description: 'Zarządzaj kontami użytkowników i uprawnieniami',
        button: 'Zarządzaj Użytkownikami',
      },
      containers: {
        title: 'Kontenery',
        description: 'Przeglądaj i zarządzaj wszystkimi kontenerami',
        button: 'Zarządzaj Kontenerami',
      },
      items: {
        title: 'Przedmioty',
        description: 'Przeglądaj i zarządzaj wszystkimi przedmiotami',
        button: 'Zarządzaj Przedmiotami',
      },
      limits: {
        title: 'Limity Funkcji',
        description: 'Konfiguruj limity AI i przechowywania dla ról',
        button: 'Zarządzaj Limitami',
      },
      reports: {
        title: 'Zgłoszenia Treści',
        description: 'Przeglądaj i zarządzaj zgłoszeniami treści',
        button: 'Zarządzaj Zgłoszeniami',
      },
      subscriptions: {
        title: 'Subskrypcje',
        description: 'Zarządzaj subskrypcjami użytkowników i planami płatności',
        button: 'Zarządzaj Subskrypcjami',
      },
      congregations: {
        title: 'Zbory',
        description: 'Zarządzaj zborami i ich członkami',
        button: 'Zarządzaj Zborami',
      },
    },
    shareLinks: {
      title: 'Linki udostępniania',
      subtitle: 'Twórz linki dające dostęp do wszystkich opublikowanych zborów bez logowania',
    },
    users: {
      title: 'Zarządzanie Użytkownikami',
      subtitle: 'Zarządzaj kontami użytkowników i uprawnieniami',
      search: 'Szukaj użytkowników...',
      loadError: 'Nie udało się załadować użytkowników',
      delete: 'Usuń',
      deleteConfirm: 'Czy na pewno chcesz usunąć tego użytkownika?',
      deleteSuccess: 'Użytkownik został usunięty',
      deleteError: 'Nie udało się usunąć użytkownika',
      empty: 'Nie znaleziono użytkowników',
      emptyDescription: 'Żaden użytkownik nie pasuje do kryteriów wyszukiwania.',
      admin: 'Administrator',
      user: 'Użytkownik',
      active: 'Aktywny',
      inactive: 'Nieaktywny',
      verified: 'Zweryfikowany',
      unverified: 'Niezweryfikowany',
      makeUser: 'Ustaw jako Użytkownika',
      makePremium: 'Ustaw jako Użytkownika Premium',
      makeAdmin: 'Ustaw jako Administratora',
      roles: {
        user: 'Użytkownik',
        admin: 'Administrator',
        premium: 'Użytkownik Premium',
      },
      changeRole: {
        action: 'zmienić rolę na {role}',
        confirm: 'Czy na pewno chcesz {action}?',
        success: 'Rola użytkownika została zmieniona na {role}',
        error: 'Nie udało się zmienić roli użytkownika',
      },
      toggleAdmin: {
        promote: 'Nadaj uprawnienia administratora',
        demote: 'Odbierz uprawnienia administratora',
        confirm: 'Czy na pewno chcesz {action}?',
        promoteSuccess: 'Użytkownik otrzymał uprawnienia administratora',
        demoteSuccess: 'Użytkownik został pozbawiony uprawnień administratora',
        error: 'Nie udało się zaktualizować uprawnień użytkownika',
      },
      columns: {
        name: 'Imię',
        email: 'Email',
        isAdmin: 'Admin',
        role: 'Rola',
        isActive: 'Aktywny',
        isEmailVerified: 'Zweryfikowany',
        createdAt: 'Utworzono',
        actions: 'Akcje',
      },
    },
    containers: {
      title: 'Zarządzanie Kontenerami',
      subtitle: 'Przeglądaj i zarządzaj wszystkimi kontenerami',
      search: 'Szukaj kontenerów...',
      loadError: 'Nie udało się załadować kontenerów',
      deleteConfirm: 'Czy na pewno chcesz usunąć ten kontener?',
      deleteSuccess: 'Kontener został usunięty',
      deleteError: 'Nie udało się usunąć kontenera',
      empty: 'Nie znaleziono kontenerów',
      emptyDescription: 'Żaden kontener nie pasuje do kryteriów wyszukiwania.',
      public: 'Publiczny',
      private: 'Prywatny',
      columns: {
        name: 'Nazwa',
        type: 'Typ',
        author: 'Autor',
        isPublic: 'Publiczny',
        itemCount: 'Przedmioty',
        createdAt: 'Utworzono',
        actions: 'Akcje',
      },
    },
    items: {
      title: 'Zarządzanie Przedmiotami',
      subtitle: 'Przeglądaj i zarządzaj wszystkimi przedmiotami',
      search: 'Szukaj przedmiotów...',
      loadError: 'Nie udało się załadować przedmiotów',
      deleteConfirm: 'Czy na pewno chcesz usunąć ten przedmiot?',
      deleteSuccess: 'Przedmiot został usunięty',
      deleteError: 'Nie udało się usunąć przedmiotu',
      empty: 'Nie znaleziono przedmiotów',
      emptyDescription: 'Żaden przedmiot nie pasuje do kryteriów wyszukiwania.',
      columns: {
        name: 'Nazwa',
        category: 'Kategoria',
        container: 'Kontener',
        author: 'Autor',
        quantity: 'Ilość',
        weight: 'Waga',
        status: 'Status',
        priority: 'Priorytet',
        createdAt: 'Utworzono',
        actions: 'Akcje',
      },
    },
    limits: {
      title: 'Limity Funkcji',
      subtitle: 'Konfiguruj limity AI i przechowywania dla ról użytkowników',
      loadError: 'Nie udało się załadować limitów',
      updateSuccess: 'Limit został zaktualizowany',
      updateError: 'Nie udało się zaktualizować limitu',
      aiLimit: 'Limit AI (USD)',
      storageLimit: 'Limit Przechowywania',
      unlimited: 'Bez limitu',
      noAccess: 'Brak dostępu',
      unlimitedPlaceholder: 'Bez limitu (zostaw puste)',
      aiLimitHint: 'Zostaw puste dla bez limitu, 0 dla braku dostępu',
      save: 'Zapisz',
      cancel: 'Anuluj',
      edit: 'Edytuj',
      roles: {
        user: 'Użytkownik',
        premium: 'Premium',
        admin: 'Administrator',
        owner: 'Właściciel',
      },
    },
    reports: {
      title: 'Zgłoszenia Treści',
      subtitle: 'Przeglądaj i zarządzaj zgłoszeniami treści',
      search: 'Szukaj zgłoszeń...',
      filterByStatus: 'Filtruj według statusu',
      total: 'Łącznie: {count}',
      updateSuccess: 'Status zgłoszenia został zaktualizowany',
      updateError: 'Nie udało się zaktualizować statusu zgłoszenia',
      markReviewed: 'Oznacz jako Przejrzane',
      markDismissed: 'Oznacz jako Odrzucone',
      markActionTaken: 'Oznacz jako Podjęto Działanie',
      makeContainerPrivate: 'Uczyń Kontener Prywatnym',
      containerMadePrivate: 'Kontener został ustawiony jako prywatny',
      makePrivateError: 'Nie udało się ustawić kontenera jako prywatny',
      actions: 'Akcje',
      empty: 'Nie znaleziono zgłoszeń',
      emptyDescription: 'Nie ma zgłoszeń treści pasujących do wybranych filtrów.',
      status: {
        all: 'Wszystkie',
        pending: 'Oczekujące',
        reviewed: 'Przejrzane',
        dismissed: 'Odrzucone',
        action_taken: 'Podjęto Działanie',
      },
      columns: {
        container: 'Kontener',
        reporter: 'Zgłaszający',
        reason: 'Powód',
        status: 'Status',
        createdAt: 'Utworzono',
        actions: 'Akcje',
      },
    },
    subscriptions: {
      title: 'Zarządzanie Subskrypcjami',
      subtitle: 'Zarządzaj subskrypcjami użytkowników i rozliczeniami',
      search: 'Szukaj subskrypcji...',
      loadError: 'Nie udało się załadować subskrypcji',
      empty: 'Nie znaleziono subskrypcji',
      emptyDescription: 'Żadna subskrypcja nie pasuje do wyszukiwania.',
      columns: {
        user: 'Użytkownik',
        email: 'Email',
        plan: 'Plan',
        billing: 'Rozliczenia',
        status: 'Status',
        grandfathered: 'Dożywotni',
        actions: 'Akcje',
      },
      plans: {
        free: 'Darmowy',
        pro: 'Pro',
        pro_plus: 'Pro Plus',
      },
      billing: {
        monthly: 'Miesięczne',
        annual: 'Roczne',
      },
      status: {
        active: 'Aktywny',
        canceled: 'Anulowany',
        past_due: 'Zaległy',
        unpaid: 'Nieopłacony',
        incomplete: 'Niekompletny',
      },
      changeTo: {
        free: 'Zmień na Darmowy',
        pro: 'Zmień na Pro',
        pro_plus: 'Zmień na Pro Plus',
      },
      changePlan: {
        confirm: 'Czy na pewno chcesz zmienić plan na {plan}?',
        success: 'Plan zmieniony na {plan}',
        error: 'Nie udało się zmienić planu',
      },
      makeGrandfathered: 'Przyznaj Dożywotni Dostęp',
      removeGrandfathered: 'Usuń Dożywotni Dostęp',
      grandfathered: {
        add: 'przyznać dożywotni dostęp',
        remove: 'usunąć dożywotni dostęp',
        confirm: 'Czy na pewno chcesz {action}?',
        success: 'Status dożywotniego dostępu zaktualizowany',
        error: 'Nie udało się zaktualizować statusu',
      },
      cancel: {
        action: 'Anuluj Subskrypcję',
        confirm: 'Czy na pewno chcesz anulować subskrypcję {plan}? To natychmiast anuluje subskrypcję, obniży plan do Free i anuluje w Stripe, jeśli dotyczy.',
        success: 'Subskrypcja {plan} została anulowana',
        error: 'Nie udało się anulować subskrypcji',
      },
      stats: {
        totalUsers: 'Wszyscy Użytkownicy',
        activeSubscriptions: 'Aktywne Subskrypcje',
        planDistribution: 'Rozkład Planów',
        revenue: 'Przychody',
        grandfathered: 'Użytkownicy Dożywotni',
        pastDue: 'Zaległe',
        ofTotal: 'z {count} ogółem',
        lifetimePro: 'Dożywotni dostęp Pro',
        requiresAttention: 'Wymaga uwagi',
        monthly: 'Miesięcznie',
        annual: 'Rocznie',
      },
    },
    congregations: {
      title: 'Zarządzanie Zborami',
      subtitle: 'Zarządzaj zborami (tenantami) i ich członkami',
      search: 'Szukaj zborów...',
      loadError: 'Nie udało się załadować zborów',
      create: 'Utwórz Zbór',
      createTitle: 'Utwórz Nowy Zbór',
      createDescription: 'Dodaj nowy zbór do systemu',
      editTitle: 'Edytuj Zbór',
      editDescription: 'Zaktualizuj informacje o zborze',
      name: 'Nazwa',
      namePlaceholder: 'Wprowadź nazwę zboru',
      nameRequired: 'Nazwa jest wymagana',
      description: 'Opis',
      descriptionPlaceholder: 'Wprowadź opis (opcjonalnie)',
      status: 'Status',
      statusDraft: 'Szkic',
      statusPublished: 'Opublikowany',
      statusPublishedUnverified: 'Opublikowany (niezweryfikowany)',
      statusNeedVerification: 'Wymaga weryfikacji',
      allStatuses: 'Wszystkie statusy',
      createSuccess: 'Zbór został utworzony pomyślnie',
      createError: 'Nie udało się utworzyć zboru',
      updateSuccess: 'Zbór został zaktualizowany pomyślnie',
      updateError: 'Nie udało się zaktualizować zboru',
      deleteConfirm: 'Usunąć ten zbór? Dane zostaną zachowane — zbór można później przywrócić.',
      deleteSuccess: 'Zbór został usunięty pomyślnie',
      deleteError: 'Nie udało się usunąć zboru',
      deleted: 'Usunięty',
      restore: 'Przywróć',
      restoreSuccess: 'Zbór został przywrócony',
      restoreError: 'Nie udało się przywrócić zboru',
      showDeleted: 'Pokaż usunięte',
      hideDeleted: 'Ukryj usunięte',
      publish: 'Opublikuj',
      publishSuccess: 'Zbór został opublikowany pomyślnie',
      publishError: 'Nie udało się opublikować zboru',
      unpublish: 'Cofnij publikację',
      unpublishSuccess: 'Publikacja zboru została cofnięta pomyślnie',
      unpublishError: 'Nie udało się cofnąć publikacji zboru',
      manageMembers: 'Zarządzaj Członkami',
      empty: 'Nie znaleziono zborów',
      emptyDescription: 'Żaden zbór nie pasuje do kryteriów wyszukiwania.',
      columns: {
        name: 'Nazwa',
        description: 'Opis',
        status: 'Status',
        createdAt: 'Utworzono',
        actions: 'Akcje',
      },
      address: {
        title: 'Adres',
        loading: 'Ładowanie adresu...',
        loadError: 'Nie udało się załadować adresu',
        street: 'Ulica',
        streetPlaceholder: 'Wprowadź adres ulicy',
        city: 'Miasto',
        cityPlaceholder: 'Wprowadź miasto',
        postalCode: 'Kod pocztowy',
        postalCodePlaceholder: 'Wprowadź kod pocztowy',
      },
      memberships: {
        title: 'Zarządzanie Członkami',
        description: 'Dodaj, edytuj lub usuń członków z tego zboru',
        addMember: 'Dodaj Członka',
        user: 'Użytkownik',
        selectUser: 'Wybierz użytkownika',
        userRequired: 'Użytkownik jest wymagany',
        role: 'Rola',
        roleMember: 'Członek',
        roleOwner: 'Właściciel',
        add: 'Dodaj Członka',
        members: 'Członkowie',
        empty: 'Brak członków',
        loadError: 'Nie udało się załadować członków',
        createSuccess: 'Członek został dodany pomyślnie',
        createError: 'Nie udało się dodać członka',
        updateSuccess: 'Rola członka została zaktualizowana pomyślnie',
        updateError: 'Nie udało się zaktualizować roli członka',
        deleteConfirm: 'Czy na pewno chcesz usunąć tego członka?',
        deleteSuccess: 'Członek został usunięty pomyślnie',
        deleteError: 'Nie udało się usunąć członka',
      },
    },
  },
}
